import {MutationTree} from "vuex";
import {DuplicatesState} from "@/store/settings/duplicates/types";

export const mutations: MutationTree<DuplicatesState> = {
  setDuplicates:(state, payload) => {
    state.duplicates = payload
  },
  setDuplicateItem:(state, payload) => {
    state.duplicateItem = payload
  }
}